import posthog from 'posthog-js';

const projectToken = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
const apiHost = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

export const isPostHogEnabled = Boolean(projectToken);

if (projectToken && typeof window !== 'undefined') {
  posthog.init(projectToken, {
    api_host: apiHost,
    defaults: '2026-05-30',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    person_profiles: 'identified_only',
    disable_session_recording: false,
    session_recording: {
      // Never record text entered into forms, including the AI chat input.
      maskAllInputs: true,
      // Avoid leaking query-string tokens or personal data into recordings.
      maskCapturedNetworkRequestFn: (request) => {
        if (request.name) {
          request.name = request.name.split('?')[0];
        }

        return request;
      },
    },
  });
}

export default posthog;
